import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    ExportExcelChatParams,
    ExportExcelParams,
    ExportExcelResponse,
    GetWhatsappChatMessagesParams,
    GetWhatsappChatMessagesResponse,
    GetWhatsappChatsParams,
    GetWhatsappChatsResponse,
    NotificationPayloadT,
    NotificationsGetListResponseT,
    NotificationsGetTypesResponseT,
} from '../types/notifications.types'

export class NotificationsRepository {
    getNotificationsList(params: any): Promise<AxiosResponse<NotificationsGetListResponseT>> {
        return http.get('/notification/api/notifications', { params })
    }

    createNotification(payload: NotificationPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/notification/api/notifications', payload)
    }

    getNotificationsTypes(params: any): Promise<AxiosResponse<NotificationsGetTypesResponseT>> {
        return http.get('/notification/api/notification-types', { params })
    }

    setDeviceToken(token: string): Promise<AxiosResponse<void>> {
        return http.post('/notification/api/push/device', {
            key: token,
            web: 1,
        })
    }

    readNotification(notification_id: number | string): Promise<AxiosResponse<void>> {
        return http.put(`/notification/api/notifications/${notification_id}/read`, {})
    }

    getWhatsappChats(
        params: GetWhatsappChatsParams
    ): Promise<AxiosResponse<GetWhatsappChatsResponse>> {
        return http.get('/notification/api/whatsapp/chats/last-messages', { params })
    }

    getWhatsappChatMessages(
        params: GetWhatsappChatMessagesParams
    ): Promise<AxiosResponse<GetWhatsappChatMessagesResponse>> {
        return http.get('/notification/api/whatsapp/message', { params })
    }

    exportExcel(params: ExportExcelParams): Promise<AxiosResponse<ExportExcelResponse>> {
        return http.get('/notification/api/whatsapp/chats/last-messages/export', {
            responseType: 'blob',
            params,
        })
    }

    exportExcelChat(params: ExportExcelChatParams): Promise<AxiosResponse<ExportExcelResponse>> {
        return http.get('/notification/api/whatsapp/messages/export', {
            responseType: 'blob',
            params,
        })
    }
}
